import React from "react";
import { useTranslation } from "react-i18next";
import { LOGO } from "../../lib/assets";
import { getServices } from "../../data/services";
import { LocaleLink } from "../../i18n/LocaleLink";

export const FooterTwo = () => {
  const { t } = useTranslation();
  const services = getServices(t);

  return (
    <footer>
      <div className="footer-area-two footer-bg-two">
        <div className="footer-top-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <div className="fw-logo">
                    <LocaleLink to="/">
                      <img src={LOGO} alt="" />
                    </LocaleLink>
                  </div>

                  <div className="footer-content">
                    <p>{t("footer.tagline")}</p>
                    <div className="footer-info">
                      <ul className="list-wrap">
                        <li>
                          <div className="icon">
                            <i className="flaticon-phone-call"></i>
                          </div>
                          <div className="content">
                            <a href="tel:0573044089089">+57 304 408 9089</a>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <i className="flaticon-clock"></i>
                          </div>
                          <div className="content">
                            <p>
                              {t("footer.hours")} <br />
                              {t("footer.sundays")}{" "}
                              <span>{t("footer.closed")}</span>
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">{t("footer.menu")}</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <LocaleLink to="/about">{t("footer.about")}</LocaleLink>
                      </li>
                      <li>
                        <LocaleLink to="/contact">
                          {t("footer.contactUs")}
                        </LocaleLink>
                      </li>
                      <li>
                        <LocaleLink to="/blog">{t("footer.blog")}</LocaleLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">{t("footer.services")}</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      {services.map((service) => (
                        <li key={service.id}>
                          <LocaleLink
                            to={service.href}
                            state={{ serviceId: service.id }}
                          >
                            {service.title}
                          </LocaleLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <h4 className="fw-title">{t("footer.newsletter")}</h4>
                  <div className="footer-newsletter">
                    <p>{t("footer.newsletterText")}</p>
                    <form action="#">
                      <input
                        type="email"
                        placeholder={t("footer.emailPlaceholder")}
                      />
                      <button type="submit">{t("footer.subscribe")}</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text-two text-center">
                  <p>{t("footer.copyright")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
